<template>
    <div class="row" v-loading="isLoading">
        <div class="form-group col-6">
            <label class="mb-0" :for="'salon_legal_entity_id' + _uid">Юрлицо площадки</label>
            <CounteragentSelect v-model="salon_legal_entity_id" :filter_type="'company'" class="multiselect-bootstrap" :id="'salon_legal_entity_id' + _uid"/>
            <div v-if="field_errors.hasOwnProperty('salon_legal_entity_id')" class="help-block invalid-feedback d-block" v-html="field_errors['salon_legal_entity_id'][0]"/>
        </div>
        <div class="form-group col-6">
            <label class="mb-0" :for="'counteragent_id' + _uid">Контрагент</label>
            <CounteragentSelect v-model="counteragent_id" :filter_type="counteragent_type" class="multiselect-bootstrap" :id="'counteragent_id' + _uid"/>
            <div v-if="field_errors.hasOwnProperty('counteragent_id')" class="help-block invalid-feedback d-block" v-html="field_errors['counteragent_id'][0]"/>
        </div>
<!--        <div class="form-group col-6">-->
<!--            <label class="mb-0" :for="'expenses_incurred' + _uid">Расходы на продажу ТС</label>-->
<!--            <input type="number" class="form-control" name="expenses_incurred" :id="'expenses_incurred' + _uid" v-model="expenses_incurred">-->
<!--            <div v-if="field_errors.hasOwnProperty('expenses_incurred')" class="help-block invalid-feedback d-block" v-html="field_errors['expenses_incurred'][0]"/>-->
<!--        </div>-->
        <div class="form-group col-6">
            <label class="mb-0" :for="'reward' + _uid">Вознаграждение</label>
            <input type="number" class="form-control" name="reward" :id="'reward' + _uid" v-model="reward">
            <div v-if="field_errors.hasOwnProperty('reward')" class="help-block invalid-feedback d-block" v-html="field_errors['reward'][0]"/>
        </div>
        <div class="form-group col-12 text-right">
            <button @click="generate" class="btn btn-light"><i class="fas fa-download mr-2"></i>Скачать документ</button>
        </div>
    </div>
</template>

<script>
import formMixin from "../formMixin";
import CounteragentSelect from "../../counteragents/CounteragentSelect";
import ProfileSelect from "../../requests/profiles/ProfileSelect";

export default {
    name: "DogovorKomissii",
    mixins: [formMixin],
    components: {CounteragentSelect, ProfileSelect},
    props: {
        form_name: {
            type: String,
            required: true,
        },
        deal: {
            type: Object,
            required: true,
        },
        counteragent_type: {
            type: String,
            required: true,
        },
    },
    data: () => ({
        isLoading: false,
        salon_legal_entity_id: null,
        counteragent_id: null,
        expenses_incurred: null,
        reward: null,
        field_errors: {},
    }),
    computed: {
        form_params() {
            return {
                form_name: this.form_name,
                salon_legal_entity_id: this.salon_legal_entity_id,
                counteragent_id: this.counteragent_id,
                expenses_incurred: this.expenses_incurred,
                reward: this.reward,
                car_id: this.deal.sale_car_id,
            };
        }
    }
}
</script>

<style scoped>

</style>
